export default {"src":"/_next/static/media/credit-score.b1078fb0.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};